import React from "react";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import {Link} from "react-router-dom";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import CardActions from "@mui/material/CardActions";
import {useTheme} from "@mui/material/styles";
import {useTranslation} from "react-i18next";

export default function Home() {
    const theme = useTheme();
    // init internationalization
    const {t} = useTranslation();

    return (
        <Grid
            id="home-container"
            container
            columnSpacing={4}
            sx={{padding: theme.spacing(8, 2)}}
        >
            <Grid item xs={12}>
                <Typography variant="h3"> {t("home.Welcome")}</Typography>
            </Grid>
            <Grid item xl={6} md={9} sm={12} sx={{padding: theme.spacing(4, 0)}}>
                <Typography variant="body1">{t("home.Goals")}</Typography>
            </Grid>
            <Grid item xl={6} md={3} sm={12}/>
            <Grid item  xl={3} md={6} sm={12}>
                <Link to="/demo-datasets" className="home-card-link">
                    <Card sx={{maxWidth: 800, borderRadius: '16px'}} id="home-to-examples-action">
                        <CardMedia
                            component="img"
                            height="150"
                            image="https://images.pexels.com/photos/3705926/pexels-photo-3705926.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
                            alt=" Check out our example experiments."
                        />
                        <CardContent sx={{minHeight: 200}}>
                            <Typography gutterBottom variant="h6" component="div">
                                {t("home.TutorialExampleTitle")}
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                                {t("home.TutorialExampleBody")}
                            </Typography>
                        </CardContent>
                        <CardActions>
                            <Button size="medium" variant="contained" sx={{"&.MuiButton-root": {minWidth: "230px"}}}>
                                {t("home.TutorialExampleButton")}
                            </Button>
                        </CardActions>
                    </Card>
                </Link>
            </Grid>
            <Grid item xl={3} md={6} sm={12}>
                <Link to="/new-dataset" className="home-card-link">
                    <Card sx={{maxWidth: 800}} id="home-to-dataset-action">
                        <CardMedia
                            component="img"
                            height="150"
                            image="https://images.pexels.com/photos/3630332/pexels-photo-3630332.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
                            alt={t('home.TutorialExampleTitle')}
                        />
                        <CardContent sx={{minHeight: 200}}>
                            <Typography gutterBottom variant="h6" component="div">
                                {t('home.TutorialDatasetTitle')}
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                                {t('home.TutorialDatasetBody')}
                            </Typography>
                        </CardContent>
                        <CardActions>
                            <Button size="medium" variant="contained" sx={{"&.MuiButton-root": {minWidth: "180px"}}}>{t('home.TutorialDatasetButton')}</Button>
                        </CardActions>
                    </Card>
                </Link>
            </Grid>
        </Grid>
    );
}
